<template>
  <el-drawer
    :visible.sync="localVisible"
    :size="drawerSize"
    direction="rtl"
    :with-header="true"
    @close="handleClose"
  >
    <template slot="title">
      <span class="drawer-title">换表详情</span>
    </template>
    
    <div v-if="changeData" class="drawer-content">
      <el-descriptions :column="1" border size="small">
        <el-descriptions-item label="ID">
          <span class="detail-value">{{ detailData.ID }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="工单编号">
          <span class="detail-value">{{ detailData.sw_order_no }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="旧表编码">
          <span class="detail-value">{{ detailData.old_feetable_address }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="新表编码">
          <span class="detail-value highlight-blue">{{ detailData.new_feetable_address }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="运营商名称">
          <span class="detail-value">{{ detailData.merchant_name }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="所属站点">
          <span class="detail-value">{{ feeTableData.site_name }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="所属分支箱">
          <span class="detail-value">{{ feeTableData.branch_box_name }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="所属分支箱资产码">
          <span class="detail-value">{{ feeTableData.assets_code }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="所属分支箱通道">
          <span class="detail-value">{{ detailData.gun_no }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="创建时间">
          <span class="detail-value">{{ detailData.create_time }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="最新修改时间">
          <span class="detail-value">{{ detailData.modify_time }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="操作人员">
          <span class="detail-value">{{ changeData.user_name }}</span>
        </el-descriptions-item>
        <!-- <el-descriptions-item label="旧表余额">
          <span class="detail-value">¥{{ changeData.oldBalance }}</span>
        </el-descriptions-item> -->
        <el-descriptions-item label="新表余额">
          <span class="detail-value highlight-green">¥{{ formatReading(detailData.send_dev_balance / 100) }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="旧表底表值">
          <span class="detail-value">{{ formatReading(detailData.cur_meter / 1000) }} kWh</span>
        </el-descriptions-item>
        <el-descriptions-item label="新表底表值">
          <span class="detail-value">{{ formatReading(detailData.new_cur_meter / 1000) }} kWh</span>
        </el-descriptions-item>
        <el-descriptions-item label="状态">
          <span :class="detailData.is_finished ? 'status-completed' : 'status-processing'">{{ detailData.is_finished ? '已完成' : '进行中' }}</span>
        </el-descriptions-item>

        <el-descriptions-item label="换表进度" v-if="!detailData.is_finished">
          <el-steps :active="currentStep" finish-status="success" align-center>
            <el-step :title="stepItem.label" v-for="(stepItem,stepIndex) in stepList" :key="stepItem.key + '_' + stepIndex"></el-step>
          </el-steps>
        </el-descriptions-item>

        <el-descriptions-item label="备注说明">
          <span class="detail-value remark">{{ detailData.remark }}</span>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    
    <div v-else class="empty-state">
      <i class="el-icon-info"></i>
      <p>暂无数据</p>
    </div>
  </el-drawer>
</template>

<script>
import {
  getFeetableSwitchInfoApi
} from '@/api/dev_archive'
export default {
  name: 'ChangeFeeTableDetails',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    changeData: {
      type: Object,
      default: null
    }
  },
  data(){
    return {
      detailData: {},
      feeTableData: {},
      currentStep: 1,
      stepList: [{
          key: 'old-meter',
          label: '获取旧表'
        },
        {
          key: 'new-meter',
          label: '检测新表'
        },
        {
          key: 'verify',
          label: '指令验证'
        },
        {
          key: 'param',
          label: '参数设置'
        },
        {
          key: 'done',
          label: '完成'
        }
      ]
    }
  },
  computed: {
    localVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    drawerSize() {
      // 计算50%的宽度
      const windowWidth = window.innerWidth
      return Math.min(windowWidth * 0.5, 800) + 'px'
    }
  },
  methods: {
    initData(rowData){
      this.detailData = rowData;
      this.getDetailsData(rowData.ID);
    },
    getDetailsData(ID){
      let requestData = {
        id: ID
      }
      getFeetableSwitchInfoApi(requestData).then((res) => {
        //console.log(res)
        this.detailData = res.data || {};
        if(this.detailData.has_send_meter_dq && this.detailData.new_cur_meter ===0 && this.detailData.cur_meter > 0){
          this.detailData.new_cur_meter = this.detailData.cur_meter
        }

        this.feeTableData = res.data.bmi_power_branch_box_feetable_json ? JSON.parse(res.data.bmi_power_branch_box_feetable_json) : {};
        if(this.detailData.has_send_address && this.detailData.has_on_lock && this.detailData.has_off_lock){
          this.currentStep = 3
        } else if(this.detailData.new_feetable_address){
          this.currentStep = 2
        } else {
          this.currentStep = 1
        }
      })
    },
    formatReading(val) {
      if (val === null || val === undefined || val === '') return '0.0';
      return Number(val).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    handleClose() {
      this.$emit('update:visible', false)
    },
  }
}
</script>

<style scoped lang="scss">
.drawer-title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
}

.drawer-content {
  padding: 20px;
}

.detail-value {
  font-size: 14px;
  color: #606266;
}

.detail-value.highlight-blue {
  color: #409EFF;
  font-weight: 600;
  font-size: 15px;
}

.detail-value.highlight-green {
  color: #67C23A;
  font-weight: 600;
  font-size: 15px;
}

.detail-value.remark {
  color: #909399;
  font-style: italic;
}

// 状态颜色
.status-completed {
  color: #67C23A;
  font-weight: 600;
}

.status-processing {
  color: #F56C6C;
  font-weight: 600;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
  color: #909399;
  
  i {
    font-size: 48px;
    margin-bottom: 16px;
  }
  
  p {
    font-size: 14px;
    margin: 0;
  }
}

// 响应式适配
@media (max-width: 768px) {
  .drawer-content {
    padding: 12px;
  }
  
  ::v-deep .el-descriptions__label,
  ::v-deep .el-descriptions__content {
    padding: 8px 10px;
  }
}
</style>